import {AbstractUrlService} from 'core/abstract/AbstractUrlService';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {PromoListPage} from 'modules/promo/pages/PromoListPage';
import {
    selectPage,
    selectPageCount,
    selectPageSize,
    selectPageSizeList,
    selectPaginationType,
    selectPromoList,
} from 'modules/promo/selectors';
import {promoSlice} from 'modules/promo/slice';
import {getPromoList} from 'modules/promo/thunks';
import {SliceProvider} from 'plugins/context/Slice/SliceProvider';
import {usePaginationUrlService} from 'plugins/modules/pagination/hooks/usePaginationUrlService';
import {PaginationProvider} from 'plugins/modules/pagination/provider';
import React, {FC, useCallback, useRef} from 'react';

export const PromoListPageProvider: FC = () => {
    const promoList = useAppSelector(selectPromoList);
    const dispatch = useAppDispatch();

    const count = useAppSelector(selectPageCount);
    const page = useAppSelector(selectPage);
    const pageSize = useAppSelector(selectPageSize);
    const paginationType = useAppSelector(selectPaginationType);
    const pageSizeList = useAppSelector(selectPageSizeList);

    const urlServiceCallback = useCallback<AbstractUrlService['onParamsChange']>(
        (searchQuery) => dispatch(getPromoList(searchQuery)),
        [dispatch]
    );
    const queryRef = useRef<URLSearchParams>(new URLSearchParams());
    const paginationUrlService = usePaginationUrlService(queryRef.current, urlServiceCallback);

    return (
        <SliceProvider slice={promoSlice}>
            <PaginationProvider
                count={count}
                page={page}
                pageSize={pageSize}
                pageSizeList={pageSizeList}
                type={paginationType}
                urlService={paginationUrlService}
            >
                <PromoListPage promoList={promoList} />
            </PaginationProvider>
        </SliceProvider>
    );
};
